// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"O0-z","subtitle":"P0-z","wrapper":"Q0-z","leftArrow":"R0-z","rightArrow":"S0-z"};